/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityModel } from '../../models/facility-model';

export interface FacilityPost$Params {
      body?: FacilityModel
}

export function facilityPost(http: HttpClient, rootUrl: string, params?: FacilityPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, facilityPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<string>;
    })
  );
}

facilityPost.PATH = '/Facility';
